// Generated by Melange

import * as Buhta_documentapis__Buhta_document_v1_document_direction from "./buhta_document_v1_document_direction.js";
import * as Buhta_documentapis__Buhta_document_v1_document_orientation from "./buhta_document_v1_document_orientation.js";
import * as Buhta_documentapis__Buhta_document_v1_document_participant_sign_status from "./buhta_document_v1_document_participant_sign_status.js";
import * as Buhta_documentapis__Buhta_document_v1_document_participant_type from "./buhta_document_v1_document_participant_type.js";
import * as Buhta_documentapis__Buhta_document_v1_signer_entity_type from "./buhta_document_v1_signer_entity_type.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_type__Google_type_date from "../../third_party/google_type/gen/google_type_date.js";
import * as Google_wkt__Google_protobuf_timestamp from "../../third_party/google_wkt/gen/google_protobuf_timestamp.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Bytes from "melange/bytes.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_document.ml",
      191,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "XmlDocument"
                          ],
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "FileDocument"
                          ],
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "$$Document"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "DocumentParticipant"
                    ]
                  ]
                },
                "V1alpha1"
              ]]
          },
          "$$Document"
        ]]
    });

const $$Document = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_document.ml",
      339,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "XmlDocument"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "FileDocument"
                    ],
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "$$Document"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "DocumentParticipant"
              ]
            ]
          },
          "V1alpha1"
        ]]
    });

const V1alpha1 = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_document.ml",
      485,
      10
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "XmlDocument"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "FileDocument"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "$$Document"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "DocumentParticipant"
        ]
      ]
    });

const $$Document$1 = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_document.ml",
      590,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "XmlDocument"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "FileDocument"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const DocumentParticipant = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_document.ml",
      830,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const XmlDocument = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_document.ml",
      621,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const FileDocument = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_document.ml",
      682,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.document.v1alpha1.Document.XmlDocument";
}

function make(dataOpt, param) {
  const data = dataOpt !== undefined ? dataOpt : "";
  return {
          data: data
        };
}

const merge_data = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "data",
            "data"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge(t1, t2) {
  return {
          data: Curry._2(merge_data, t1.data, t2.data)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "data",
                    "data"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._2(serialize, writer, param.data);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(data) {
  return {
          data: data
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.Document.XmlDocument", spec(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.data);
  };
}

function constructor$1(data) {
  return {
          data: data
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.Document.XmlDocument", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, XmlDocument, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.document.v1alpha1.Document.FileDocument";
}

function make$1(dataOpt, mime_type, param) {
  const data = dataOpt !== undefined ? dataOpt : Stdlib__Bytes.of_string("");
  return {
          data: data,
          mime_type: mime_type
        };
}

const merge_data$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "data",
            "data"
          ],
          Ocaml_protoc_plugin__Spec.bytes,
          Stdlib__Bytes.of_string("")
        ]));

const merge_mime_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "mime_type",
            "mimeType"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

function merge$1(t1, t2) {
  return {
          data: Curry._2(merge_data$1, t1.data, t2.data),
          mime_type: Curry._2(merge_mime_type, t1.mime_type, t2.mime_type)
        };
}

function spec$1(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "data",
                    "data"
                  ],
                  Ocaml_protoc_plugin__Spec.bytes,
                  Stdlib__Bytes.of_string("")
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "mime_type",
                        "mimeType"
                      ],
                      Ocaml_protoc_plugin__Spec.string
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._3(serialize$1, writer, param.data, param.mime_type);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(data, mime_type) {
  return {
          data: data,
          mime_type: mime_type
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.Document.FileDocument", spec$1(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.data, param.mime_type);
  };
}

function constructor$3(data, mime_type) {
  return {
          data: data,
          mime_type: mime_type
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.Document.FileDocument", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, FileDocument, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.document.v1alpha1.Document";
}

function make$2(id, directionOpt, stateOpt, nameOpt, register_numOpt, register_date, document_numOpt, document_date, participantsOpt, create_time, update_time, source_typeOpt, contentOpt, orientation, preview_url, param) {
  const direction = directionOpt !== undefined ? directionOpt : Curry._1(Buhta_documentapis__Buhta_document_v1_document_direction.Buhta.$$Document.V1.DocumentDirection.from_int_exn, 0);
  const state = stateOpt !== undefined ? stateOpt : "";
  const name = nameOpt !== undefined ? nameOpt : "";
  const register_num = register_numOpt !== undefined ? register_numOpt : "";
  const document_num = document_numOpt !== undefined ? document_numOpt : "";
  const participants = participantsOpt !== undefined ? participantsOpt : /* [] */0;
  const source_type = source_typeOpt !== undefined ? source_typeOpt : "";
  const content = contentOpt !== undefined ? contentOpt : "not_set";
  return {
          id: id,
          direction: direction,
          state: state,
          name: name,
          register_num: register_num,
          register_date: register_date,
          document_num: document_num,
          document_date: document_date,
          participants: participants,
          create_time: create_time,
          update_time: update_time,
          source_type: source_type,
          content: content,
          orientation: orientation,
          preview_url: preview_url
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_direction = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "direction",
            "direction"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_documentapis__Buhta_document_v1_document_direction.Buhta.$$Document.V1.DocumentDirection),
          Curry._1(Buhta_documentapis__Buhta_document_v1_document_direction.Buhta.$$Document.V1.DocumentDirection.from_int_exn, 0)
        ]));

const merge_state = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "state",
            "state"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            4,
            "name",
            "name"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_register_num = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            5,
            "register_num",
            "registerNum"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let = Google_type__Google_type_date.Google.Type.$$Date;

const merge_register_date = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            6,
            "register_date",
            "registerDate"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

const merge_document_num = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            7,
            "document_num",
            "documentNum"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let$1 = Google_type__Google_type_date.Google.Type.$$Date;

const merge_document_date = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            8,
            "document_date",
            "documentDate"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

const merge_participants = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            21,
            "participants",
            "participants"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: DocumentParticipant.name,
                make: DocumentParticipant.make,
                from_proto: DocumentParticipant.from_proto,
                from_proto_exn: DocumentParticipant.from_proto_exn,
                to_proto: DocumentParticipant.to_proto,
                to_proto$p: DocumentParticipant.to_proto$p,
                merge: DocumentParticipant.merge,
                to_json: DocumentParticipant.to_json,
                from_json_exn: DocumentParticipant.from_json_exn,
                from_json: DocumentParticipant.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

const $$let$2 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_create_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            31,
            "create_time",
            "createTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              })
        ]));

const $$let$3 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_update_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            32,
            "update_time",
            "updateTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$3.name,
                make: $$let$3.make,
                from_proto: $$let$3.from_proto,
                from_proto_exn: $$let$3.from_proto_exn,
                to_proto: $$let$3.to_proto,
                to_proto$p: $$let$3.to_proto$p,
                merge: $$let$3.merge,
                to_json: $$let$3.to_json,
                from_json_exn: $$let$3.from_json_exn,
                from_json: $$let$3.from_json
              })
        ]));

const merge_source_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            33,
            "source_type",
            "sourceType"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_oneof_content__Xml = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
          [
            0,
            "",
            ""
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: XmlDocument.name,
                make: XmlDocument.make,
                from_proto: XmlDocument.from_proto,
                from_proto_exn: XmlDocument.from_proto_exn,
                to_proto: XmlDocument.to_proto,
                to_proto$p: XmlDocument.to_proto$p,
                merge: XmlDocument.merge,
                to_json: XmlDocument.to_json,
                from_json_exn: XmlDocument.from_json_exn,
                from_json: XmlDocument.from_json
              })
        ]));

const merge_oneof_content__File = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
          [
            0,
            "",
            ""
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: FileDocument.name,
                make: FileDocument.make,
                from_proto: FileDocument.from_proto,
                from_proto_exn: FileDocument.from_proto_exn,
                to_proto: FileDocument.to_proto,
                to_proto$p: FileDocument.to_proto$p,
                merge: FileDocument.merge,
                to_json: FileDocument.to_json,
                from_json_exn: FileDocument.from_json_exn,
                from_json: FileDocument.from_json
              })
        ]));

const merge_orientation = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            36,
            "orientation",
            "orientation"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_documentapis__Buhta_document_v1_document_orientation.Buhta.$$Document.V1.DocumentOrientation)
        ]));

const merge_preview_url = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            37,
            "preview_url",
            "previewUrl"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

function merge$2(t1, t2) {
  const match = t1.content;
  const match$1 = t2.content;
  let tmp;
  let exit = 0;
  if (typeof match === "string") {
    exit = 1;
  } else {
    const variant = match.NAME;
    if (variant === "Xml") {
      if (typeof match$1 === "string" || match$1.NAME !== "Xml") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Xml",
          VAL: Curry._2(merge_oneof_content__Xml, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "File" && !(typeof match$1 === "string" || match$1.NAME !== "File")) {
      tmp = {
        NAME: "File",
        VAL: Curry._2(merge_oneof_content__File, match.VAL, match$1.VAL)
      };
    } else {
      exit = 1;
    }
  }
  if (exit === 1) {
    tmp = match$1 === "not_set" ? match : match$1;
  }
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          direction: Curry._2(merge_direction, t1.direction, t2.direction),
          state: Curry._2(merge_state, t1.state, t2.state),
          name: Curry._2(merge_name, t1.name, t2.name),
          register_num: Curry._2(merge_register_num, t1.register_num, t2.register_num),
          register_date: Curry._2(merge_register_date, t1.register_date, t2.register_date),
          document_num: Curry._2(merge_document_num, t1.document_num, t2.document_num),
          document_date: Curry._2(merge_document_date, t1.document_date, t2.document_date),
          participants: Curry._2(merge_participants, t1.participants, t2.participants),
          create_time: Curry._2(merge_create_time, t1.create_time, t2.create_time),
          update_time: Curry._2(merge_update_time, t1.update_time, t2.update_time),
          source_type: Curry._2(merge_source_type, t1.source_type, t2.source_type),
          content: tmp,
          orientation: Curry._2(merge_orientation, t1.orientation, t2.orientation),
          preview_url: Curry._2(merge_preview_url, t1.preview_url, t2.preview_url)
        };
}

function spec$2(param) {
  const $$let = Google_type__Google_type_date.Google.Type.$$Date;
  const $$let$1 = Google_type__Google_type_date.Google.Type.$$Date;
  const $$let$2 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$3 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "direction",
                        "direction"
                      ],
                      Ocaml_protoc_plugin__Spec.$$enum(Buhta_documentapis__Buhta_document_v1_document_direction.Buhta.$$Document.V1.DocumentDirection),
                      Curry._1(Buhta_documentapis__Buhta_document_v1_document_direction.Buhta.$$Document.V1.DocumentDirection.from_int_exn, 0)
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "state",
                            "state"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                4,
                                "name",
                                "name"
                              ],
                              Ocaml_protoc_plugin__Spec.string,
                              ""
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                  [
                                    5,
                                    "register_num",
                                    "registerNum"
                                  ],
                                  Ocaml_protoc_plugin__Spec.string,
                                  ""
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                      [
                                        6,
                                        "register_date",
                                        "registerDate"
                                      ],
                                      Ocaml_protoc_plugin__Spec.message({
                                            name: $$let.name,
                                            make: $$let.make,
                                            from_proto: $$let.from_proto,
                                            from_proto_exn: $$let.from_proto_exn,
                                            to_proto: $$let.to_proto,
                                            to_proto$p: $$let.to_proto$p,
                                            merge: $$let.merge,
                                            to_json: $$let.to_json,
                                            from_json_exn: $$let.from_json_exn,
                                            from_json: $$let.from_json
                                          })
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                          [
                                            7,
                                            "document_num",
                                            "documentNum"
                                          ],
                                          Ocaml_protoc_plugin__Spec.string,
                                          ""
                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                              [
                                                8,
                                                "document_date",
                                                "documentDate"
                                              ],
                                              Ocaml_protoc_plugin__Spec.message({
                                                    name: $$let$1.name,
                                                    make: $$let$1.make,
                                                    from_proto: $$let$1.from_proto,
                                                    from_proto_exn: $$let$1.from_proto_exn,
                                                    to_proto: $$let$1.to_proto,
                                                    to_proto$p: $$let$1.to_proto$p,
                                                    merge: $$let$1.merge,
                                                    to_json: $$let$1.to_json,
                                                    from_json_exn: $$let$1.from_json_exn,
                                                    from_json: $$let$1.from_json
                                                  })
                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                                                  [
                                                    21,
                                                    "participants",
                                                    "participants"
                                                  ],
                                                  Ocaml_protoc_plugin__Spec.message({
                                                        name: DocumentParticipant.name,
                                                        make: DocumentParticipant.make,
                                                        from_proto: DocumentParticipant.from_proto,
                                                        from_proto_exn: DocumentParticipant.from_proto_exn,
                                                        to_proto: DocumentParticipant.to_proto,
                                                        to_proto$p: DocumentParticipant.to_proto$p,
                                                        merge: DocumentParticipant.merge,
                                                        to_json: DocumentParticipant.to_json,
                                                        from_json_exn: DocumentParticipant.from_json_exn,
                                                        from_json: DocumentParticipant.from_json
                                                      }),
                                                  Ocaml_protoc_plugin__Spec.not_packed
                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                      [
                                                        31,
                                                        "create_time",
                                                        "createTime"
                                                      ],
                                                      Ocaml_protoc_plugin__Spec.message({
                                                            name: $$let$2.name,
                                                            make: $$let$2.make,
                                                            from_proto: $$let$2.from_proto,
                                                            from_proto_exn: $$let$2.from_proto_exn,
                                                            to_proto: $$let$2.to_proto,
                                                            to_proto$p: $$let$2.to_proto$p,
                                                            merge: $$let$2.merge,
                                                            to_json: $$let$2.to_json,
                                                            from_json_exn: $$let$2.from_json_exn,
                                                            from_json: $$let$2.from_json
                                                          })
                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                          [
                                                            32,
                                                            "update_time",
                                                            "updateTime"
                                                          ],
                                                          Ocaml_protoc_plugin__Spec.message({
                                                                name: $$let$3.name,
                                                                make: $$let$3.make,
                                                                from_proto: $$let$3.from_proto,
                                                                from_proto_exn: $$let$3.from_proto_exn,
                                                                to_proto: $$let$3.to_proto,
                                                                to_proto$p: $$let$3.to_proto$p,
                                                                merge: $$let$3.merge,
                                                                to_json: $$let$3.to_json,
                                                                from_json_exn: $$let$3.from_json_exn,
                                                                from_json: $$let$3.from_json
                                                              })
                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                              [
                                                                33,
                                                                "source_type",
                                                                "sourceType"
                                                              ],
                                                              Ocaml_protoc_plugin__Spec.string,
                                                              ""
                                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.oneof([
                                                                  {
                                                                    hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                                                                          [
                                                                            34,
                                                                            "xml",
                                                                            "xml"
                                                                          ],
                                                                          Ocaml_protoc_plugin__Spec.message({
                                                                                name: XmlDocument.name,
                                                                                make: XmlDocument.make,
                                                                                from_proto: XmlDocument.from_proto,
                                                                                from_proto_exn: XmlDocument.from_proto_exn,
                                                                                to_proto: XmlDocument.to_proto,
                                                                                to_proto$p: XmlDocument.to_proto$p,
                                                                                merge: XmlDocument.merge,
                                                                                to_json: XmlDocument.to_json,
                                                                                from_json_exn: XmlDocument.from_json_exn,
                                                                                from_json: XmlDocument.from_json
                                                                              }),
                                                                          [
                                                                            (function (v) {
                                                                                return {
                                                                                        NAME: "Xml",
                                                                                        VAL: v
                                                                                      };
                                                                              }),
                                                                            (function (param) {
                                                                                if (typeof param === "string") {
                                                                                  throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                                                                            MEL_EXN_ID: Stdlib.Invalid_argument,
                                                                                            _1: "Cannot destruct given oneof"
                                                                                          });
                                                                                }
                                                                                if (param.NAME === "Xml") {
                                                                                  return param.VAL;
                                                                                }
                                                                                throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                                                                          MEL_EXN_ID: Stdlib.Invalid_argument,
                                                                                          _1: "Cannot destruct given oneof"
                                                                                        });
                                                                              })
                                                                          ]
                                                                        ]),
                                                                    tl: {
                                                                      hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                                                                            [
                                                                              35,
                                                                              "file",
                                                                              "file"
                                                                            ],
                                                                            Ocaml_protoc_plugin__Spec.message({
                                                                                  name: FileDocument.name,
                                                                                  make: FileDocument.make,
                                                                                  from_proto: FileDocument.from_proto,
                                                                                  from_proto_exn: FileDocument.from_proto_exn,
                                                                                  to_proto: FileDocument.to_proto,
                                                                                  to_proto$p: FileDocument.to_proto$p,
                                                                                  merge: FileDocument.merge,
                                                                                  to_json: FileDocument.to_json,
                                                                                  from_json_exn: FileDocument.from_json_exn,
                                                                                  from_json: FileDocument.from_json
                                                                                }),
                                                                            [
                                                                              (function (v) {
                                                                                  return {
                                                                                          NAME: "File",
                                                                                          VAL: v
                                                                                        };
                                                                                }),
                                                                              (function (param) {
                                                                                  if (typeof param === "string") {
                                                                                    throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                                                                              MEL_EXN_ID: Stdlib.Invalid_argument,
                                                                                              _1: "Cannot destruct given oneof"
                                                                                            });
                                                                                  }
                                                                                  if (param.NAME === "File") {
                                                                                    return param.VAL;
                                                                                  }
                                                                                  throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                                                                            MEL_EXN_ID: Stdlib.Invalid_argument,
                                                                                            _1: "Cannot destruct given oneof"
                                                                                          });
                                                                                })
                                                                            ]
                                                                          ]),
                                                                      tl: /* [] */0
                                                                    }
                                                                  },
                                                                  (function (param) {
                                                                      if (typeof param === "string") {
                                                                        return Stdlib.failwith("Impossible case");
                                                                      } else if (param.NAME === "File") {
                                                                        return 1;
                                                                      } else {
                                                                        return 0;
                                                                      }
                                                                    })
                                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                      [
                                                                        36,
                                                                        "orientation",
                                                                        "orientation"
                                                                      ],
                                                                      Ocaml_protoc_plugin__Spec.$$enum(Buhta_documentapis__Buhta_document_v1_document_orientation.Buhta.$$Document.V1.DocumentOrientation)
                                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                          [
                                                                            37,
                                                                            "preview_url",
                                                                            "previewUrl"
                                                                          ],
                                                                          Ocaml_protoc_plugin__Spec.string
                                                                        ]), Ocaml_protoc_plugin__Spec.nil)))))))))))))));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry.app(serialize$2, [
        writer,
        param.id,
        param.direction,
        param.state,
        param.name,
        param.register_num,
        param.register_date,
        param.document_num,
        param.document_date,
        param.participants,
        param.create_time,
        param.update_time,
        param.source_type,
        param.content,
        param.orientation,
        param.preview_url
      ]);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(id, direction, state, name, register_num, register_date, document_num, document_date, participants, create_time, update_time, source_type, content, orientation, preview_url) {
  return {
          id: id,
          direction: direction,
          state: state,
          name: name,
          register_num: register_num,
          register_date: register_date,
          document_num: document_num,
          document_date: document_date,
          participants: participants,
          create_time: create_time,
          update_time: update_time,
          source_type: source_type,
          content: content,
          orientation: orientation,
          preview_url: preview_url
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.Document", spec$2(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
                param.id,
                param.direction,
                param.state,
                param.name,
                param.register_num,
                param.register_date,
                param.document_num,
                param.document_date,
                param.participants,
                param.create_time,
                param.update_time,
                param.source_type,
                param.content,
                param.orientation,
                param.preview_url
              ]);
  };
}

function constructor$5(id, direction, state, name, register_num, register_date, document_num, document_date, participants, create_time, update_time, source_type, content, orientation, preview_url) {
  return {
          id: id,
          direction: direction,
          state: state,
          name: name,
          register_num: register_num,
          register_date: register_date,
          document_num: document_num,
          document_date: document_date,
          participants: participants,
          create_time: create_time,
          update_time: update_time,
          source_type: source_type,
          content: content,
          orientation: orientation,
          preview_url: preview_url
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.Document", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "XmlDocument"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "FileDocument"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, $$Document$1, {
      XmlDocument: XmlDocument,
      FileDocument: FileDocument,
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

function name$3(param) {
  return ".buhta.document.v1alpha1.DocumentParticipant";
}

function make$3(id, type$pOpt, signer_typeOpt, sign_statusOpt, sign_accept_time, tin, name, contact, email, phone, param) {
  const type$p = type$pOpt !== undefined ? type$pOpt : Curry._1(Buhta_documentapis__Buhta_document_v1_document_participant_type.Buhta.$$Document.V1.DocumentParticipantType.from_int_exn, 0);
  const signer_type = signer_typeOpt !== undefined ? signer_typeOpt : Curry._1(Buhta_documentapis__Buhta_document_v1_signer_entity_type.Buhta.$$Document.V1.SignerEntityType.from_int_exn, 0);
  const sign_status = sign_statusOpt !== undefined ? sign_statusOpt : Curry._1(Buhta_documentapis__Buhta_document_v1_document_participant_sign_status.Buhta.$$Document.V1.DocumentParticipantSignStatus.from_int_exn, 0);
  return {
          id: id,
          "type'": type$p,
          signer_type: signer_type,
          sign_status: sign_status,
          sign_accept_time: sign_accept_time,
          tin: tin,
          name: name,
          contact: contact,
          email: email,
          phone: phone
        };
}

const merge_id$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_type$p = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "type",
            "type"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_documentapis__Buhta_document_v1_document_participant_type.Buhta.$$Document.V1.DocumentParticipantType),
          Curry._1(Buhta_documentapis__Buhta_document_v1_document_participant_type.Buhta.$$Document.V1.DocumentParticipantType.from_int_exn, 0)
        ]));

const merge_signer_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "signer_type",
            "signerType"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_documentapis__Buhta_document_v1_signer_entity_type.Buhta.$$Document.V1.SignerEntityType),
          Curry._1(Buhta_documentapis__Buhta_document_v1_signer_entity_type.Buhta.$$Document.V1.SignerEntityType.from_int_exn, 0)
        ]));

const merge_sign_status = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            4,
            "sign_status",
            "signStatus"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_documentapis__Buhta_document_v1_document_participant_sign_status.Buhta.$$Document.V1.DocumentParticipantSignStatus),
          Curry._1(Buhta_documentapis__Buhta_document_v1_document_participant_sign_status.Buhta.$$Document.V1.DocumentParticipantSignStatus.from_int_exn, 0)
        ]));

const $$let$4 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_sign_accept_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            5,
            "sign_accept_time",
            "signAcceptTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$4.name,
                make: $$let$4.make,
                from_proto: $$let$4.from_proto,
                from_proto_exn: $$let$4.from_proto_exn,
                to_proto: $$let$4.to_proto,
                to_proto$p: $$let$4.to_proto$p,
                merge: $$let$4.merge,
                to_json: $$let$4.to_json,
                from_json_exn: $$let$4.from_json_exn,
                from_json: $$let$4.from_json
              })
        ]));

const merge_tin = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            6,
            "tin",
            "tin"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_name$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            7,
            "name",
            "name"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_contact = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            8,
            "contact",
            "contact"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_email = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            9,
            "email",
            "email"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_phone = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            10,
            "phone",
            "phone"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

function merge$3(t1, t2) {
  return {
          id: Curry._2(merge_id$1, t1.id, t2.id),
          "type'": Curry._2(merge_type$p, t1["type'"], t2["type'"]),
          signer_type: Curry._2(merge_signer_type, t1.signer_type, t2.signer_type),
          sign_status: Curry._2(merge_sign_status, t1.sign_status, t2.sign_status),
          sign_accept_time: Curry._2(merge_sign_accept_time, t1.sign_accept_time, t2.sign_accept_time),
          tin: Curry._2(merge_tin, t1.tin, t2.tin),
          name: Curry._2(merge_name$1, t1.name, t2.name),
          contact: Curry._2(merge_contact, t1.contact, t2.contact),
          email: Curry._2(merge_email, t1.email, t2.email),
          phone: Curry._2(merge_phone, t1.phone, t2.phone)
        };
}

function spec$3(param) {
  const $$let = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "type",
                        "type"
                      ],
                      Ocaml_protoc_plugin__Spec.$$enum(Buhta_documentapis__Buhta_document_v1_document_participant_type.Buhta.$$Document.V1.DocumentParticipantType),
                      Curry._1(Buhta_documentapis__Buhta_document_v1_document_participant_type.Buhta.$$Document.V1.DocumentParticipantType.from_int_exn, 0)
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "signer_type",
                            "signerType"
                          ],
                          Ocaml_protoc_plugin__Spec.$$enum(Buhta_documentapis__Buhta_document_v1_signer_entity_type.Buhta.$$Document.V1.SignerEntityType),
                          Curry._1(Buhta_documentapis__Buhta_document_v1_signer_entity_type.Buhta.$$Document.V1.SignerEntityType.from_int_exn, 0)
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                4,
                                "sign_status",
                                "signStatus"
                              ],
                              Ocaml_protoc_plugin__Spec.$$enum(Buhta_documentapis__Buhta_document_v1_document_participant_sign_status.Buhta.$$Document.V1.DocumentParticipantSignStatus),
                              Curry._1(Buhta_documentapis__Buhta_document_v1_document_participant_sign_status.Buhta.$$Document.V1.DocumentParticipantSignStatus.from_int_exn, 0)
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                  [
                                    5,
                                    "sign_accept_time",
                                    "signAcceptTime"
                                  ],
                                  Ocaml_protoc_plugin__Spec.message({
                                        name: $$let.name,
                                        make: $$let.make,
                                        from_proto: $$let.from_proto,
                                        from_proto_exn: $$let.from_proto_exn,
                                        to_proto: $$let.to_proto,
                                        to_proto$p: $$let.to_proto$p,
                                        merge: $$let.merge,
                                        to_json: $$let.to_json,
                                        from_json_exn: $$let.from_json_exn,
                                        from_json: $$let.from_json
                                      })
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                      [
                                        6,
                                        "tin",
                                        "tin"
                                      ],
                                      Ocaml_protoc_plugin__Spec.string
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                          [
                                            7,
                                            "name",
                                            "name"
                                          ],
                                          Ocaml_protoc_plugin__Spec.string
                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                              [
                                                8,
                                                "contact",
                                                "contact"
                                              ],
                                              Ocaml_protoc_plugin__Spec.string
                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                  [
                                                    9,
                                                    "email",
                                                    "email"
                                                  ],
                                                  Ocaml_protoc_plugin__Spec.string
                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                      [
                                                        10,
                                                        "phone",
                                                        "phone"
                                                      ],
                                                      Ocaml_protoc_plugin__Spec.string
                                                    ]), Ocaml_protoc_plugin__Spec.nil))))))))));
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
    });

function to_proto$p$3(writer, param) {
  Curry.app(serialize$3, [
        writer,
        param.id,
        param["type'"],
        param.signer_type,
        param.sign_status,
        param.sign_accept_time,
        param.tin,
        param.name,
        param.contact,
        param.email,
        param.phone
      ]);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(id, type$p, signer_type, sign_status, sign_accept_time, tin, name, contact, email, phone) {
  return {
          id: id,
          "type'": type$p,
          signer_type: signer_type,
          sign_status: sign_status,
          sign_accept_time: sign_accept_time,
          tin: tin,
          name: name,
          contact: contact,
          email: email,
          phone: phone
        };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
    });

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$3, writer);
            });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.DocumentParticipant", spec$3(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
                param.id,
                param["type'"],
                param.signer_type,
                param.sign_status,
                param.sign_accept_time,
                param.tin,
                param.name,
                param.contact,
                param.email,
                param.phone
              ]);
  };
}

function constructor$7(id, type$p, signer_type, sign_status, sign_accept_time, tin, name, contact, email, phone) {
  return {
          id: id,
          "type'": type$p,
          signer_type: signer_type,
          sign_status: sign_status,
          sign_accept_time: sign_accept_time,
          tin: tin,
          name: name,
          contact: contact,
          email: email,
          phone: phone
        };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.DocumentParticipant", spec$3(undefined), constructor$7);
    });

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$3, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, DocumentParticipant, {
      make: make$3,
      to_proto: to_proto$3,
      from_proto: from_proto$3,
      to_json: to_json$3,
      from_json: from_json$3,
      name: name$3,
      merge: merge$3,
      to_proto$p: to_proto$p$3,
      from_proto_exn: from_proto_exn$3,
      from_json_exn: from_json_exn$3
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "XmlDocument"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "FileDocument"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "$$Document"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "DocumentParticipant"
        ]
      ]
    }, V1alpha1, {
      $$Document: $$Document$1,
      DocumentParticipant: DocumentParticipant
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "XmlDocument"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "FileDocument"
                    ],
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "$$Document"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "DocumentParticipant"
              ]
            ]
          },
          "V1alpha1"
        ]]
    }, $$Document, {
      V1alpha1: V1alpha1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "XmlDocument"
                          ],
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "FileDocument"
                          ],
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "$$Document"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "DocumentParticipant"
                    ]
                  ]
                },
                "V1alpha1"
              ]]
          },
          "$$Document"
        ]]
    }, Buhta, {
      $$Document: $$Document
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
